import { render } from "./App.vue?vue&type=template&id=76b078d7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=76b078d7&lang=scss"
script.render = render

export default script